module.exports = __webpack_public_path__ + "img/WIX.b4ebbef1.svg";